import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";

export interface DeleteContactPhoneNumberPayload {
  id: string;
  phoneNumber: string;
}

export function useDeleteContactPhoneNumber() {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: async (payload: DeleteContactPhoneNumberPayload) => {
      const result = await Contact.deleteContactPhoneNumber(payload);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete phone number");
      }
      return result.data.data ?? true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contact"] });
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
    },
  });

  return {
    deleteContactPhoneNumber: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
    deleteError: deleteMutation.error,
  };
}
